// extracted by mini-css-extract-plugin
module.exports = {"hrWrap":"hrBlog-module--hrWrap--25YPs"};